module.exports = __webpack_public_path__ + "static/media/25 Closed Guard.8755fe3f.jpg";